import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface IEditListEditPayload {
    id: string
    data: {
        title?: string
        editors?: string[]
        managers?: string[]
    }
    sagaCB?: {
        onSuccess: any
        onError?: any
    }
}

export interface IListState {
    status: string
    data: any
    errors: any
}

const initialState: IListState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const editSlice = createSlice({
    name: 'hub/edit-list/edit',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<IEditListEditPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload.data
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const editActions = editSlice.actions
export default editSlice.reducer
